import { QuestionType } from "@simplyk/common";

import { QuestionScope, RateOption } from "../types";

export const QUESTION_TYPES_WITH_CHOICES = [QuestionType.Multiple, QuestionType.MultipleCheckboxes];
export const FUND_DESIGNATION_TYPE = "fund-designation" as const;
export const COMMUNICATION_PREFERENCES_TYPE = "communication-preferences" as const;
export type ResponseFormatType = QuestionType | typeof FUND_DESIGNATION_TYPE | typeof COMMUNICATION_PREFERENCES_TYPE;

export type QuestionFormKind = "donation-form" | "ticketing" | "newsletter-form";

export interface ChoiceFormData {
  _key: string;
  id?: string;
  body: string;
  sortIndex: number;
  maximum: number | null;
  remainingCapacity?: number;
}

export interface FormValues {
  question: string;
  type: ResponseFormatType;
  required: boolean;
  choices: ChoiceFormData[];
  scope: QuestionScope;
  askForAllRates: boolean;
  ratesAssigned: RateOption[];
  isMaximumActive: boolean;
}
